export default "__VITE_ASSET__ebwb0RVU__"